import {Component, computed, input} from '@angular/core';
import {TranslocoDirective} from '@jsverse/transloco';
import {CommonModule} from '@angular/common';
import {LoyaltyRadialBarComponent} from './loyalty-score-bar/loyalty-radial-bar.component';
import {LoyaltyLevel, Size} from '../../services/model';

@Component({
  selector: 'lib-pill-loyalty',
  imports: [
    LoyaltyRadialBarComponent,
    TranslocoDirective,
    CommonModule
  ],
  templateUrl: './pill-loyalty.component.html',
  styleUrl: './pill-loyalty.component.scss'
})
export class PillLoyaltyComponent {

  loyaltyScore = input.required<number>();
  loyaltyLevel = input.required<LoyaltyLevel>();
  size = input<Size>(Size.SMALL);
  highContrast = input<boolean>(false);
  pillClass = computed(() => {
    let response = {
      'small': this.size() === Size.SMALL
    }

    if (this.highContrast()) {
      return {...response, "high-contrast": true};
    }

    const pillColorClass = this.getPillColorClass(this.loyaltyLevel());
    if (pillColorClass) {
      response = {...response, [pillColorClass]: true};
    }

    return response;
  });

  private getPillColorClass(loyaltyLevel: LoyaltyLevel): string | undefined {
    switch (loyaltyLevel) {
      case LoyaltyLevel.DEVOTED:
        return 'purple';
      case LoyaltyLevel.LOYAL:
      case LoyaltyLevel.FREQUENT:
        return 'green';
      case LoyaltyLevel.CASUAL:
        return 'peach';
      default:
        return undefined;
    }
  }

  protected readonly LoyaltyLevel = LoyaltyLevel;
  protected readonly Size = Size;
}
